<template>
   <div class="wrapper">
      <div>
         <CRow>
            <CCol col="4">
               <CCard>
                  <CCardHeader><b>Curriculum Info</b></CCardHeader>
                  <CListGroup>
                     <CListGroupItem href="#">
                        Curriculum Name : {{ datas.data.name }}
                     </CListGroupItem>
                     <CListGroupItem href="#">
                        Description : {{ datas.data.description }}
                     </CListGroupItem>
                  </CListGroup>
               </CCard>
               <CCard>
                  <CCardHeader><b>Image</b></CCardHeader>
                  <CListGroup>
                     <CListGroupItem href="#">
                        Background Image
                        <CRow>
                           <CCol>
                              <img
                                 class="mt-3 mb-3"
                                 v-bind:src="getImage(datas.data.bg_image_url)"
                                 height="150"
                                 width="250"
                              />
                           </CCol>
                        </CRow>
                     </CListGroupItem>

                     <CListGroupItem href="#">
                        Banner Image
                        <CRow>
                           <CCol>
                              <img
                                 class="mt-3 mb-3"
                                 v-bind:src="
                                    getImage(datas.data.banner_image_url)
                                 "
                                 height="150"
                                 width="250"
                              />
                           </CCol>
                        </CRow>
                     </CListGroupItem>
                  </CListGroup>
               </CCard>
            </CCol>
            <CCol col="8">
               <CCard>
                  <CCardHeader
                     ><b>Class List</b>                  
                      <CButton
                        v-if="datas.data.list_class_template.length > 0"
                        class="ml-2"
                        size="sm"
                        variant="outline"
                        color="info"
                        @click="add_class(datas.data.id)"
                        >Add More Class</CButton
                     >
                     <CButton
                        v-if="datas.data.list_class_template.length === 0"
                        class="ml-2"
                        size="sm"
                        variant="outline"
                        color="info"
                        @click="assign_class(datas.data.id)"
                        >Assign Class</CButton
                     >
                  </CCardHeader>
                  <CListGroup>
                     <CListGroupItem
                        v-for="item in datas.data.list_class_template"
                        :key="item.id"
                     >
                        <CRow>
                           <CCol>
                              {{ item.class_template.name }}
                           </CCol>
                           <CCol class="col-3">
                              <CButton
                              size="sm"
                              variant="outline"
                              color="danger"
                              block
                              @click="remove_class(item.id,item.batch_id)"
                              >Remove Class</CButton>     
                           </CCol>
                        </CRow>
                     </CListGroupItem>
                  </CListGroup>
               </CCard>
            </CCol>
         </CRow>

         <assignmodal></assignmodal>
         <addmodal></addmodal>
         <alertmodal></alertmodal>
      </div>
   </div>
</template>

<script>
import _ from "lodash";
import axios from "axios";

import classbatch from "@/services/batch";
import assignmodal from "./assign_class";
import addmodal from "./add_class";
import EventBus from "@/eventBus";
import alertmodal from "@/views/alert/modal.vue";
import store from "@/store.js";

export default {
   name: "detailmodal",
   components: { alertmodal, assignmodal,addmodal },
   data() {
      return {
         mode: "",
         form:{
            id:'',
            class_batch_template_id:'',
      },
         datas: [],
         list_class_template: [],
      };
      
   },
   mounted() {
      this.load();

      EventBus.$on("PAGE_UPDATE", (data) => {
         if (data) {
            this.load();
         }
      });
   },
     beforeDestroy() {
    // removing eventBus listener
    EventBus.$off('OPEN_MODAL_ASSIGN_CLASS')
  },
   methods: {
      load() {
         classbatch.getBatchbyID(this.$route.query.Pud).then((res) => {
            this.datas = res;
         });
      },
      getImage(url) {
         if (url) {
            return url;
         } else {
            return axios.defaults.baseURL + "/getfile/memberphoto/no_photo.jpg";
         }
      },
      
      assign_class: function(id) {
         //SET PERMISSION EACH FEATURE
         let Permission = store.state.user.authenticated.permission;
         if (typeof Permission != "undefined") {
            if (
               Permission.indexOf(
                  "Create/edit group (including edit coach & iCares for the group)"
               ) !== -1
            ) {
               //IF ALLOW
               // const classIDSelected = (this.datas.data.list_class_template.map(item => item.template_id))
               // console.log("classIDSelected", classIDSelected);
               var params = { title: "Assign Class", mode: "edit", data: id };
               EventBus.$emit("OPEN_MODAL_ASSIGN_CLASS", params);
               //END ALLOW
            } else {
               //IF NOT
               var params = {
                  title: "Error",
                  mode: "danger",
                  data: "unautenticated",
               };
               EventBus.$emit("OPEN_MODAL_ALERT", params);
               console.log(" open modal edit");
            }
         }
         //SET END
      },
      add_class: function(id) {
         //SET PERMISSION EACH FEATURE
         let Permission = store.state.user.authenticated.permission;
         if (typeof Permission != "undefined") {
            if (
               Permission.indexOf(
                  "Create/edit group (including edit coach & iCares for the group)"
               ) !== -1
            ) {
               //IF ALLOW
               // const classIDSelected = (this.datas.data.list_class_template.map(item => item.template_id))
               // console.log("classIDSelected", classIDSelected);
               var params = { title: "Assign Class", mode: "edit", data: id };
               EventBus.$emit("OPEN_MODAL_ADD_CLASS", params);
               //END ALLOW
            } else {
               //IF NOT
               var params = {
                  title: "Error",
                  mode: "danger",
                  data: "unautenticated",
               };
               EventBus.$emit("OPEN_MODAL_ALERT", params);
               console.log(" open modal edit");
            }
         }
         //SET END
      },

      remove_class(id,batch_id){
         console.log(id,'ini id')
      this.show = false;
      if(confirm("Do you really want to remove this class ?")){
          classbatch.remove_class(id,batch_id)
          .then(res => {
             
            //this.load()
            EventBus.$emit('PAGE_UPDATE', true)
            var params = {title: 'Success', mode:'success', data:res.message}
            EventBus.$emit('OPEN_MODAL_ALERT', params)
          }).catch ((err) => {
            var params = {title: 'Error', mode:'danger', data:err.response.data.message}
            EventBus.$emit('OPEN_MODAL_ALERT', params)
          })
        }
    },
   },
};
</script>
